import { call, put, select } from 'typed-redux-saga';
import { ActionType, createAction } from 'typesafe-actions';
import { currentContextMenuSelector } from './index';
import { ContextMenuElem, ContextMenuHandler } from './types';

type CloseContextMenuPayload = Record<string, never>;

export const closeContextMenu = createAction(
  '@components/closeContextMenu',
)<CloseContextMenuPayload>();

export const afterCloseContextMenu = createAction(
  '@components/afterCloseContextMenu',
)<CloseContextMenuPayload>();

export const handleCloseContextMenu: ContextMenuHandler<
  typeof closeContextMenu
> = state => state;

export const handleAfterCloseContextMenu: ContextMenuHandler<
  typeof afterCloseContextMenu
> = state => {
  return {
    ...state,
    currentContextMenu: undefined,
  };
};

export function* closeContextMenuSaga(
  params: ActionType<typeof closeContextMenu>,
): Generator {
  const contextMenu = (yield select(
    currentContextMenuSelector,
  )) as ContextMenuElem;

  if (contextMenu) {
    if (contextMenu.onContextMenuClosed) {
      yield call(contextMenu.onContextMenuClosed);
    }
    yield put(afterCloseContextMenu({}));
  } else {
    console.error('Attempting to close a context menu while none exist');
  }
}
